import { helpers } from '../helpers.js';

var newslettter = {
	init: function () {
		const self = this;

		self.subscribeUserFromModal();
		self.changeNewsletterFromProfile();
		self.unsubscribeFromNewsletterFromProfile();
	},

	unsubscribeFromNewsletterFromProfile: function() {
		const self 		= this;
		let formsList 	= [];

		if( ! jQuery( '.js-profileNewsletterUnsbuscribe' ) ) {
			return false;
		}

		jQuery( '.js-profileNewsletterUnsbuscribe .button' ).on( 'click', function(e){
            e.preventDefault();
            let messageContainer = jQuery('.profileNewsletterUnsubscribeMessage');

			helpers.pctApiCall({
				action: 'unsubscribe_logged_in_user_to_newsletter',
				list: formsList,
			}).then( response => {
				if( ! response.success ) {
                    messageContainer.text(response.data.message );
					return false;
				}
                messageContainer.text(response.data.message );
			}).catch(error => {
                messageContainer.text('Error' );
			});
		});
	},

	changeNewsletterFromProfile: function() {
		const self 		= this;
		let formsList 	= [];

		if( ! jQuery( '.js-profileNewsletter' ) ) {
			return false;
		}

		jQuery( '.js-profileNewsletter .button' ).on( 'click', function(e){
            e.preventDefault();

            let button = jQuery(this);
            let form = button.closest('.js-profileNewsletter');

            let messageContainer = jQuery('.profileNewsletterSaveMessage');

            if( form ) {
                form.find('.newsletter-picker input[type="checkbox"]:checked').each(function() {
                    if( jQuery(this).attr('name').includes('parent') === false ) {
                        let radioValue = jQuery(this).val();
                        formsList.push( radioValue );
                    }
                });
            }
	
			helpers.pctApiCall({
				action: 'subscribe_logged_in_user_to_newsletter',
				list: formsList,
			}).then( response => {
				if( ! response.success ) {
                    messageContainer.text(response.data.message );
					return false;
				}
                messageContainer.text(response.data.message);
			}).catch(error => {
                messageContainer.text('Error' );
				console.error( 'Error subscribing user: ' , error); 
			});
		});
	},

	subscribeUserFromModal: function() {
		const self 		= this;
		let formsList 	= [];
		let userEmail 	= '';

		if( ! jQuery( '.newsletter-modal' ) ) {
			return false;
		}

		jQuery( '.js-openNewsletterModal' ).on( 'click', function(){
			userEmail = jQuery( '#newsletter-email' );

			jQuery( '.block-newsletter__form__error' ).addClass( 'd-none' );

			if( ! helpers.isEmail( userEmail.val() ) ) {
				jQuery( '.block-newsletter__form__error' ).removeClass( 'd-none' );
				return false;
			}

			jQuery.fancybox.open({
				src: '#newsletter-modal',
				type : 'inline',
				touch: false,
			});
		});
		
		jQuery( '#newsletter-modal .button' ).on( 'click', function(){
			formsList = [];

			let button = jQuery( this );
			button.attr( 'disabled', 'disabled' );

			jQuery('#newsletter-modal input[type="checkbox"]:checked').each(function() {
                if (jQuery(this).attr('name').includes('parent') === false) {
                    let radioValue = jQuery(this).val();
                    formsList.push( radioValue );
                }
			});

			self.emptyMessage();

			helpers.pctApiCall({
				action: 'subscribe_user_to_newsletter',
				user_email: userEmail.val(),
				list: formsList,
			}).then( response => {
				if( ! response.success ) {
					button.removeAttr( 'disabled' );
					self.showMessage( response.data.message, true );
					
					return false; // error hláška
				}
	
				self.showMessage( response.data.message );	
				button.removeAttr( 'disabled' );
			}).catch(error => {
				console.error( 'Error subscribing user: ' , error); 
				button.removeAttr( 'disabled' );
			});
		});
	},

	showMessage: function( message, error = false ) {
		const self = this;

		jQuery( '.js-openNewsletterModalResponse' ).text( message );
		jQuery( '.js-openNewsletterModalResponse' ).addClass( 'error' );
	},

	emptyMessage: function() {
		jQuery( '.js-openNewsletterModalResponse' ).html( '' );
		jQuery( '.js-openNewsletterModalResponse' ).attr( 'class', 'js-openNewsletterModalResponse' );
	}
};

export { newslettter };